// extracted by mini-css-extract-plugin
module.exports = {"containerBlack":"styles_containerBlack__-5g-S","container":"styles_container__2v6Hy","border":"styles_border__pEyam","borderBlack":"styles_borderBlack__25LgY"};